import { GenericCollectionFactory } from "../../_generics";
import { GENERIC_IDS } from "../../_constants/generics.constants";

export const ClockinVacationStore = GenericCollectionFactory(GENERIC_IDS.CLOCKINS_VACATION, "uid");